import PageContainer from 'layouts/PageContainer'
import TrimCheckupInfo from './ui/TrimCheckupInfo'

const TrimCheckupPage = () => {
	return (
		<PageContainer>
			<TrimCheckupInfo />
		</PageContainer>
	)
}

export default TrimCheckupPage
